import React from 'react';



const base_cls = " transition duration-300 py-2 px-2 rounded w-full font-medium text-sm outline-none"

const list_cls = " transition duration-300 font-bold py-0.5 px-1 rounded-full"

const colors = {
    'primary':' bg-primary text-white hover:bg-primary-lighten',
    'secondary':' bg-secondary text-white',
    'disabled':' bg-disabled text-gray-600 cursor-not-allowed',
    'transparent': ' bg-transparent text-primary hover:bg-light-selected'
}

export function FormButton(props) {
    const {state_attrs} = props
    const cls = () => {
    
    let base = props.variant === "list" ? list_cls:base_cls
    base = props.className ? base.concat(props.className):base
    const color = state_attrs.readonly ? 'disabled':props.color
    return base.concat(colors[color])

    }
    
    return (
    <button 
        type={props.type || 'button'}
        className={cls()}
        style={{display:state_attrs.invisible ? 'none':'',...props.style}}
        disabled={state_attrs.readonly}
        variant={props.variant}
        onClick={props.onClick}
    >
            {props.children}

    </button>

    )

}

export default FormButton;